import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { PrivateBill_BilledTo } from "@/Common/Models/UI/Enums";
import { SavePrivateBillRequestBuilder } from "@/Patient/Api/Builders/SavePrivateBillRequestBuilder";
import { IBillableService } from "@/Patient/Models/UI/History/IBillableService";
import { IPatientPrivateBillModel } from "@/Patient/Models/UI/History/IPatientPrivateBillModel";
import { SavePrivateBillRequestModel } from "../Models/Billing/SavePrivateBillRequestModel";

class BuildSavePrivateBillRequestHelper {
    public static PrepareRequestData(
        privateBillModel: IPatientPrivateBillModel,
        inactivableResponsePatientId: string,
        isFromClose: boolean,
        createdById: string,
        billedServices: IBillableService[],
        encounterId?: string
    ): SavePrivateBillRequestModel {
        const selectedProviders = privateBillModel.get("SelectedClinicians")?.toArray();
        const recipientDetails = privateBillModel.get("SelectedBillRecipientDetails");

        let fromEditProviderId: string;
        if (selectedProviders == null) {
            fromEditProviderId = cacheStore.EmployeeCache
                .find(employee => {
                    const creator = cacheStore.GetCliniciansPersonsByContactFacetId(employee.ContactFacet_id);
                    return creator.NameWithPrefix === privateBillModel.get("Provider");
                })?.ContactFacet_id;
        }
        const currentProviderId = Array.isArray(selectedProviders) && selectedProviders[0] ? selectedProviders[0]?.ContactFacetId : fromEditProviderId;

        let requestBuilder = new SavePrivateBillRequestBuilder()
            .setDateOfVisit(MyleHelper.GetStandardizedDateString(privateBillModel.get("SelectedDateOfVisit")))
            .setSiteId(privateBillModel.get("SelectedSiteId"))
            .setProviderId(currentProviderId)
            .setCreatedById(createdById)
            .setPatientId(inactivableResponsePatientId)
            .setPaymentMethod(Number(privateBillModel.get("SelectedPaymentMethod")))
            .setDiscountType(privateBillModel.get("IsCashSelected") === true ? 0 : 1)
            .setGSTPercent(privateBillModel.get("GSTPercent"))
            .setQSTPercent(privateBillModel.get("QSTPercent"))
            .setHSTPercent(privateBillModel.get("HSTPercent"))
            .setGenericTaxPercent(privateBillModel.get("GenericTaxPercent"))
            .setDiscount(privateBillModel.get("NewBillDiscount"))
            .setTotalGST(privateBillModel.get("NewBillGSTTotal"))
            .setTotalQST(privateBillModel.get("NewBillQSTTotal"))
            .setTotalHST(privateBillModel.get("NewBillHSTTotal"))
            .setTotalGenericTax(privateBillModel.get("NewBillGenericTaxTotal"))
            .setTotal(privateBillModel.get("NewBillTotal"))
            .setNotes(privateBillModel.get("NewBillNotes"))
            .setIsFromClose(isFromClose)
            .setIsFromEdition(privateBillModel.get("IsEditBill"))
            .setPrivateBillId(privateBillModel.get("PrivateBillId"))
            .setEncounterId(encounterId)
            .setBilledServices(billedServices)
            .setBilledTo(Number(PrivateBill_BilledTo.Patient));

        if (cacheStore.ClinicSettings.EnablePrivateBillRecipient) {
            requestBuilder = requestBuilder.setRecipientName(recipientDetails.RecipientName)
                .setRecipientAddress(recipientDetails.RecipientAddress)
                .setRecipientPhoneNumber(recipientDetails.RecipientPhoneNumber)
                .setRecipientFaxNumber(recipientDetails.RecipientFaxNumber)
                .setBilledTo(Number(privateBillModel.get("SelectedBillBilledTo")));
        }

        return requestBuilder.build();
    }
}

export { BuildSavePrivateBillRequestHelper };
